module.exports = __webpack_public_path__ + "static/media/status_delivered.afc392d4.svg";